import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { getDefaultLangAlias, prependLangAlias } from "../../hooks/langAlias";

// Catches pre-language-prefix storefront URLs (old bookmarks, links
// already indexed by search engines, etc.) and 301-equivalent redirects
// them to the same path under the visitor's language alias, instead of
// letting them 404 or silently misroute against the new /:langAlias tree.
export default function LegacyLangRedirect() {
  const location = useLocation();
  const { langs } = useSelector((state) => state.misc);
  const alias = getDefaultLangAlias(langs);
  return (
    <Navigate
      to={prependLangAlias(alias, location.pathname, location.search)}
      replace
    />
  );
}
